<template>
  <v-list-tile style="height: 28px">
      <v-list-tile-avatar size="30" class="icon-wrapper">
        <v-icon size="18" :color="color">{{icon}}</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>
          <div class="caption text-xs-left" v-html="text"></div>
        </v-list-tile-title>
      </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  name: "FeatureItem",
  props:{
    color: {
      type: String,
      default: 'primary'
    },
    text: {
      type: String,
      required: true
    },
    icon:{
      type: String,
      default: 'far fa-check-circle'
    }
  }
}
</script>

<style scoped>
  .icon-wrapper{
    min-width: 35px !important;
    width: 30px !important;
  }
</style>